export default __webpack_public_path__ + "static/10-yard-dumpster-fdcaf5a58919365be232de76f392072c.jpg";